//
// Copyright 2026 DXOS.org
//

// @import-as-namespace

import { pipe } from 'effect/Function';
import * as Predicate from 'effect/Predicate';
import * as Schema from 'effect/Schema';

import * as Collection from './Collection.ts';
import * as Feed from './Feed.ts';
import * as Obj from './Obj.ts';
import * as Type from './Type.ts';
import * as View from './View.ts';

/**
 * Abstract set of objects, represented by a view, feed, or collection.
 * Schema-level union of the underlying type entities (rebuilt via
 * `Type.getSchema`) so this can still be consumed by Schema-side APIs such
 * as `Filter.type(...)` on a union.
 */
export type Dataset = Feed.Feed | Collection.Collection | View.View;
export const Dataset = Schema.Union([
  Type.getSchema(Feed.Feed),
  Type.getSchema(Collection.Collection),
  Type.getSchema(View.View),
]);

/**
 * Type guard for datasets.
 *
 * @performance O(1); at most three type-URI comparisons.
 */
export const isDataset: (value: unknown) => value is Dataset = pipe(
  Obj.instanceOf(Feed.Feed),
  Predicate.or(Obj.instanceOf(Collection.Collection)),
  Predicate.or(Obj.instanceOf(View.View)),
);
